/**
 * Default homologacion object matching frontend structure
 * This is a copy of the shared config to avoid CRA build issues
 */
import type { Homologacion } from '../types';

export const defaultHomologacion: Homologacion = {
  informacion_general: {
    modelo: null,
    n_asientos: null,
    n_faros_giratorios: { 
      key: 'Nº Faros Giratorios', code:'FGIR', value_ai: null, value_human: null, min: 0, max: null, NA: null, ai: true  
    },
    contraseñas: [
      { key: 'E2 10R 03 03069 SESALY', code:'E2 10R 03 03069', value_ai: null, value_human: null, NA: null, ai: true },
      { key: 'E2 00 90136 RINDER', code:'E2 00 90136', value_ai: null, value_human: null, NA: null, ai: true },
      { key: 'E1 10R 032738 - HELLA', code:'E1 10R 032738', value_ai: null, value_human: null, NA: null, ai: true },
    ],
    funcionalidad: true,
    funcionalidades: [
      { key: 'Funcionalidad luz de cruce', check: true, ai: false },
      { key: 'Funcionalidad luces de carretera', check: true, ai: false },
      { key: 'Funcionalidad luz antiniebla delantera', check: true, ai: false },
      { key: 'Funcionalidad luz de posición', check: true, ai: false },
      { key: 'Funcionalidad intermitente', check: true, ai: false },
      { key: 'Funcionalidad warning', check: true, ai: false },
    ],
  },
  olympus_slm: {
    dimensiones: [
      { key: 'G - LONGITUD TOTAL', code: 'G', value_ai: null, value_human: null, check: null, min: 3000, max: 14000, NA: null, ai: true },
      { key: 'L - VOLADIZO DELANTERO', code: 'L', value_ai: null, value_human: null, check: null, min: 300, max: 3000, NA: null, ai: true },
      { key: 'K - VOLADIZO TRASERO', code: 'K', value_ai: null, value_human: null, check: null, min: 500, max: 5000, NA: null, ai: true },
      { key: 'H - ANCHURA MÁXIMA DEL EQUIPO', code: 'H', value_ai: null, value_human: null, check: null, min: 1500, max: 2560, NA: null, ai: true },
      { key: 'U - ALTURA MÁXIMA DEL EQUIPO', code: 'U', value_ai: null, value_human: null, check: null, min: 1500, max: 4100, NA: null, ai: true },
      { key: 'I - ALTURA DE LA CAJA AL SUELO', code: 'I', value_ai: null, value_human: null, check: null, min: 800, max: 2000, NA: null, ai: true },
      { key: 'BL - LONGITUD CARROZADA', code: 'BL', value_ai: null, value_human: null, check: null, min: 2000, max: 13500, NA: null, ai: false},
      { key: 'A - DISTANCIA ENTRE EJES 1º A 2º', code: 'A', value_ai: null, value_human: null, check: null, min: 1000, max: 5000, NA: null, ai: true },
      { key: 'B - DISTANCIA ENTRE EJES 2º A 3º', code: 'B', value_ai: null, value_human: null, check: null, min: 200, max: 5000, NA: null, ai: true },
      { key: 'C - DISTANCIA DES DEL ÚLTIMO EJE A CORTE DE CHASÍS', code: 'C', value_ai: null, value_human: null, check: null, min: 100, max: 3000, NA: null, ai: false },
      { key: 'E - DISTANCIA DES DEL EJE DELANTERO A INICIO DE CARROCERÍA', code: 'E', value_ai: null, value_human: null, check: null, min: 100, max: 2000, NA: null, ai: true },
      { key: 'M - SALIENTE FRONTAL (TFF, SISTEMA DE RIEGO, …)', code: 'M', value_ai: null, value_human: null, check: null, min: null, max: 2000, NA: null, ai: false },
      { key: 'N - DISTANCIA DES DE EJE DELANTERO A INICIO DE BASTIDOR', code: 'N', value_ai: null, value_human: null, check: null, min: 100, max: 5000, NA: null, ai: false },
      { key: 'Ñ - DISTANCIA DES DE FALSO BASTIDOR DELANTERO A TRASERO', code: 'Ñ', value_ai: null, value_human: null, check: null, min: null, max: 5000, NA: null, ai: false },
      { key: 'Xu - DISTANCIA DES DE EJE TRASERO A FINAL DE CAJA', code: 'Xu', value_ai: null, value_human: null, check: null, min: 200, max: 3000, NA: null, ai: true },
    ],
    dimensiones_false_bastidor: [
      { key: 'O/P', delante: null, detras: null , NA: null, ai: false},
      { key: 'A', delante: null, detras: null, NA: null, ai: false },
      { key: 'B', delante: null, detras: null, NA: null, ai: false },
      { key: 'C', delante: null, detras: null, NA: null, ai: false},
    ],
    posicion: [
      { key: 'Transversal', value_ai: null, value_human: null, NA: null, ai: false },
      { key: 'Vertical', value_ai: null, value_human: null, NA: null, ai: false },
    ],
    gcs_sketch_images_path: null,
  },
  lavacontenedores: {
    dimensiones: [
      { key: 'G - LONGITUD TOTAL', code: 'G', value_ai: null, value_human: null, check: null, min: 3000, max: 14000 , NA: null, ai: true},
      { key: 'L - VOLADIZO DELANTERO', code: 'L', value_ai: null, value_human: null, check: null, min: 300, max: 3000, NA: null, ai: true },
      { key: 'K - VOLADIZO TRASERO', code: 'K', value_ai: null, value_human: null, check: null, min: 500, max: 5000, NA: null, ai: true },
      { key: 'H - ANCHURA MÁXIMA DEL EQUIPO', code: 'H', value_ai: null, value_human: null, check: null, min: 1500, max: 2550, NA: null, ai: true },
      { key: 'U - ALTURA MÁXIMA DEL EQUIPO', code: 'U', value_ai: null, value_human: null, check: null, min: 1500, max: 4000, NA: null, ai: true },
      { key: 'I - ALTURA DE LA CAJA AL SUELO', code: 'I', value_ai: null, value_human: null, check: null, min: 800, max: 2000, NA: null, ai: true },
      { key: 'BL - LONGITUD CARROZADA', code: 'BL', value_ai: null, value_human: null, check: null, min: 2000, max: 13500, NA: null, ai: false },
      { key: 'A - DISTANCIA ENTRE EJES 1º A 2º', code: 'A', value_ai: null, value_human: null, check: null, min: 1000, max: 5000, NA: null, ai: true },
      { key: 'B - DISTANCIA ENTRE EJES 2º A 3º', code: 'B', value_ai: null, value_human: null, check: null, min: 200, max: 5000, NA: null, ai: true },
      { key: 'C - DISTANCIA DES DEL ÚLTIMO EJE A CORTE DE CHASÍS', code: 'C', value_ai: null, value_human: null, check: null, min: 100, max: 3000, NA: null, ai: false },
      { key: 'E - DISTANCIA DES DEL EJE DELANTERO A INICIO DE CARROCERÍA', code: 'E', value_ai: null, value_human: null, check: null, min: 100, max: 2000, NA: null, ai: true },
      // { key: 'F - DE EJE DELANTERO A FINAL CABINA', code: 'F', value_ai: null, value_human: null, check: null, min: 100, max: 2000 , NA: null,ai: true},
      // { key: 'E - DISTANCIA DES DEL EJE DELANTERO A INICIO DE CARROCERÍA', code: 'E', value_ai: null, value_human: null, check: null, min: 100, max: 2000,NA: null, ai: true },
      { key: 'M - SALIENTE FRONTAL (TFF, SISTEMA DE RIEGO, …)', code: 'M', value_ai: null, value_human: null, check: null, min: null, max: 2000, NA: null, ai: false },
      { key: 'N - DISTANCIA DES DE EJE DELANTERO A INICIO DE BASTIDOR', code: 'N', value_ai: null, value_human: null, check: null, min: 100, max: 5000, NA: null, ai: false},
      { key: 'Ñ - DISTANCIA DES DE FALSO BASTIDOR DELANTERO A TRASERO', code: 'Ñ', value_ai: null, value_human: null, check: null, min: null, max: 5000, NA: null, ai: false },
    ],
    dimensiones_false_bastidor: [
      { key: 'O/P', delante: null, detras: null, NA: null, ai: false },
      { key: 'A', delante: null, detras: null, NA: null, ai: false },
      { key: 'B', delante: null, detras: null, NA: null, ai: false },
      { key: 'C', delante: null, detras: null, NA: null, ai: false },
    ],
    posicion: [
      { key: 'Transversal', value_ai: null, value_human: null, NA: null, ai: false },
      { key: 'Vertical', value_ai: null, value_human: null, NA: null, ai: false },
    ],
    gcs_sketch_images_path: null,
  },
  luces_laterales: {
    contraseñas: [
      { key: 'E9 1317', code: 'E9 1317', value_ai: null, value_human: null, NA: null, ai: true },
    ],
    dimensiones: [
      { key: 'D1 (mín 250 mm)', code: 'ALD1', value_ai: null, value_human: null, check: null, min: 250, max: 2000, NA: null, ai: true  },
      { key: 'D2 (máx 1500 mm)', code: 'ALD2', value_ai: null, value_human: null, check: null, min: 150, max: 1500, NA: null, ai: true },
      { key: 'D3 (máx 3000 mm)', code: 'ALD3', value_ai: null, value_human: null, check: null, min: 200, max: 3000, NA: null, ai: true  },
      { key: 'D4 - 1 (máx 3000 mm)', code: 'ALD4-1', value_ai: null, value_human: null, check: null, min: 200, max: 3000, NA: null, ai: true  },
      { key: 'D4 - 2 (máx 3000 mm)', code: 'ALD4-2', value_ai: null, value_human: null, check: null, min: 200, max: 3000, NA: null, ai: true  },
      { key: 'D4 - 3 (máx 3000 mm)', code: 'ALD4-3', value_ai: null, value_human: null, check: null, min: 200, max: 3000, NA: null, ai: true  },
      { key: 'D5 (máx 1000 mm)', code: 'ALD5', value_ai: null, value_human: null, check: null, min: 50, max: 1000, NA: null, ai: true  },
    ],
    funcionalidad: true,
    gcs_sketch_images_path: null,
  },
  catadioptricos_laterales: {
    contraseñas: [
      { key: 'IA E9 02 009', code: null, value_ai: null, value_human: null, NA: null, ai: false  },
    ],
    dimensiones: [
      { key: 'D1 (mín 250 mm)', code: 'CLD1', value_ai: null, value_human: null, check: null, min: 250, max: 1200, NA: null, ai: true  },
      { key: 'D2 (máx 900 mm)', code: 'CLD2', value_ai: null, value_human: null, check: null, min: 250, max: 900, NA: null, ai: true  },
      { key: 'D3 (máx 3000 mm)', code: 'CLD3', value_ai: null, value_human: null, check: null, min: 200, max: 3000, NA: null, ai: true  },
      { key: 'D4 - 1 (máx 3000 mm)', code: 'CLD4-1', value_ai: null, value_human: null, check: null, min: 200, max: 3000, NA: null, ai: true  },
      { key: 'D4 - 2 (máx 3000 mm)', code: 'CLD4-2', value_ai: null, value_human: null, check: null, min: 200, max: 3000, NA: null, ai: true  },
      { key: 'D4 - 3 (máx 3000 mm)', code: 'CLD4-3', value_ai: null, value_human: null, check: null, min: 200, max: 3000 , NA: null, ai: true  },
      { key: 'D5 (máx 1000 mm)', code: 'CLD5', value_ai: null, value_human: null, check: null, min: 50, max: 1000, NA: null, ai: true  },
    ],
    gcs_sketch_images_path: null,
  },
  frenado: {
    contraseñas_halógenas: [
      { key: 'E1 02130 (Superior)', code: 'E1 02130', value_ai: null, value_human: null, NA: null, ai: false  },
      { key: 'E17 0303 (Inferior)', code: 'E17 0303', value_ai: null, value_human: null, NA: null, ai: false },
    ],
    contraseñas_led: [
      { key: 'E6 0859 (Superior)', code: 'E6 0859--TOP', value_ai: null, value_human: null, NA: null, ai: true },
      { key: 'E6 0859 (Inferior)', code: 'E6 0859--BOTTOM', value_ai: null, value_human: null, NA: null, ai: true },
    ],
    dimensiones: [
      { key: 'AT1 (máx 400 mm)', code: 'FAT1', value_ai: null, value_human: null, check: null, min: null, max: 400, NA: null, ai: true },
      { key: 'AT2', code: 'FAT2', value_ai: null, value_human: null, check: null, min: 20, max: 500, NA: null, ai: true },
      { key: 'AT3', code: 'FAT3', value_ai: null, value_human: null, check: null, min: 500, max: 2550, NA: null, ai: true },
      { key: 'AT4 (máx 400 mm)', code: 'FAT4', value_ai: null, value_human: null, check: null, min: null, max: 400, NA: null, ai: true },
      { key: 'AT5', code: 'FAT5', value_ai: null, value_human: null, check: null, min: 50, max: 500, NA: null, ai: true },
      { key: 'AT6 (mín 600 mm)', code: 'FAT6', value_ai: null, value_human: null, check: null, min: 600, max: 2550, NA: null, ai: true },
      { key: 'AT7 (mín 350 mm)', code: 'FAT7', value_ai: null, value_human: null, check: null, min: 350, max: 2000, NA: null, ai: true },
      { key: 'AT8 (máx 2100 mm)', code: 'FAT8', value_ai: null, value_human: null, check: null, min: 250, max: 2100, NA: null, ai: true },
      { key: 'AT9', code: 'FAT9', value_ai: null, value_human: null, check: null, min: 100, max: 2500, NA: null, ai: true },
      { key: 'AT10 (mín 2100 mm)', code: 'FAT10', value_ai: null, value_human: null, check: null, min: 100, max: 2100, NA: null, ai: true },
    ],
    angulos: [
      { key: 'Ángulo 1 visión horizontal izquierdo (80º)', check: true, ai: false },
      { key: 'Ángulo 2 visión horizontal izquierdo (45º)', check: true, ai: false },
      { key: 'Ángulo 1 visión horizontal derecho (45º)', check: true, ai: false },
      { key: 'Ángulo 2 visión horizontal derecho (80º)', check: true, ai: false },
      { key: 'Ángulo de visión vertical superior (15º)', check: true, ai: false },
      { key: 'Ángulo de visión vertical inferior (15º)', check: true, ai: false },
    ],
    funcionalidad: true,
    gcs_sketch_images_path: null,
  },
  antiniebla: {
    contraseñas_halógenas: [
      { key: 'E12 38007', code: 'E12 38007', value_ai: null, value_human: null, NA: null, ai: false },
    ],
    contraseñas_led: [
      { key: 'E6 0007', code: 'E6 0007', value_ai: null, value_human: null, NA: null, ai: false },
    ],
    dimensiones: [
      { key: 'AN1 (máx 400 mm)', code: 'AN1', value_ai: null, value_human: null, check: null, min: null, max: 400, NA: null, ai: true },
      { key: 'AN2 (mín 250 mm)', code: 'AN2', value_ai: null, value_human: null, check: null, min: 250, max: 1500, NA: null, ai: true },
      { key: 'AN3 (máx 1000 mm)', code: 'AN3', value_ai: null, value_human: null, check: null, min: 100, max: 1000, NA: null, ai: true },
    ],
    angulos: [
      { key: 'Ángulo 1 visión horizontal izquierdo (80º)', check: true, ai: false },
      { key: 'Ángulo 2 visión horizontal izquierdo (45º)', check: true, ai: false },
      { key: 'Ángulo 1 visión horizontal derecho (45º)', check: true, ai: false },
      { key: 'Ángulo 2 visión horizontal derecho (80º)', check: true, ai: false },
      { key: 'Ángulo de visión vertical superior (15º)', check: true, ai: false },
      { key: 'Ángulo de visión vertical inferior (15º)', check: true, ai: false },
    ],
    funcionalidad: true,
    gcs_sketch_images_path: null,
  },
  marcha_atras: {
    contraseñas_halógenas: [
      { key: 'E17 0303', code: 'E17 0303',value_ai: null, value_human: null, NA: null, ai: false },
    ],
    contraseñas_led: [
      { key: 'E6 0007', code: 'E6 0007',value_ai: null, value_human: null, NA: null, ai: false },
    ],
    dimensiones: [
      { key: 'MA1 (máx 400 mm)', code: 'MA1', value_ai: null, value_human: null, check: null, min: null, max: 400, NA: null, ai: true },
      { key: 'MA2 (mín 600 mm)', code: 'MA2', value_ai: null, value_human: null, check: null, min: 600, max: 2550, NA: null, ai: true },
      { key: 'MA3 (mín 250 mm)', code: 'MA3', value_ai: null, value_human: null, check: null, min: 250, max: 1500, NA: null, ai: true },
      { key: 'MA4 (máx 1200 mm)', code: 'MA4', value_ai: null, value_human: null, check: null, min: 150, max: 1200, NA: null, ai: true },
    ],
    angulos: [
      { key: 'Ángulo 1 visión horizontal izquierdo (80º)', check: true, ai: false },
      { key: 'Ángulo 2 visión horizontal izquierdo (45º)', check: true, ai: false },
      { key: 'Ángulo 1 visión horizontal derecho (45º)', check: true, ai: false },
      { key: 'Ángulo 2 visión horizontal derecho (80º)', check: true, ai: false },
      { key: 'Ángulo de visión vertical superior (15º)', check: true, ai: false },
      { key: 'Ángulo de visión vertical inferior (15º)', check: true, ai: false },
    ],
    funcionalidad: true,
    gcs_sketch_images_path: null,
  },
  catadioptricos_traseros: {
    contraseñas: [
      { key: 'IA E9 009 - Redondos', code: null, value_ai: null, value_human: null, NA: null, ai: false },
      { key: 'IA 92031 - Rectangulares', code: null, value_ai: null, value_human: null, NA: null, ai: false },
    ],
    dimensiones: [
      { key: 'CT1 (máx 400 mm)', code: 'CT1', value_ai: null, value_human: null, check: null, min: null, max: 400, NA: null, ai: true },
      { key: 'CT2', code: 'CT2', value_ai: null, value_human: null, check: null, min: 50, max: 500, NA: null, ai: true },
      { key: 'CT3 (mín 600 mm)', code: 'CT3', value_ai: null, value_human: null, check: null, min: 600, max: 2550, NA: null, ai: true },
      { key: 'CT4 (mín 250 mm)', code: 'CT4', value_ai: null, value_human: null, check: null, min: 250, max: 1500, NA: null, ai: true },
      { key: 'CT5 (máx 900 mm)', code: 'CT5', value_ai: null, value_human: null, check: null, min: 150, max: 900, NA: null, ai: true},
    ],
    angulos: [
      { key: 'Ángulo 1 visión horizontal izquierdo (30º)', check: true, ai: false },
      { key: 'Ángulo 2 visión horizontal izquierdo (30º)', check: true, ai: false },
      { key: 'Ángulo 1 visión horizontal derecho (30º)', check: true, ai: false },
      { key: 'Ángulo 2 visión horizontal derecho (30º)', check: true, ai: false },
      { key: 'Ángulo de visión vertical 1 (10º)', check: true, ai: false },
      { key: 'Ángulo de visión vertical 2 (10º)', check: true, ai: false },
    ],
    gcs_sketch_images_path: null,
  },
  galibos_delanteros: {
    dimensiones: [
      { key: 'GD1', code: 'GD1', value_ai: null, value_human: null, check: null, min: null, max: 2500, NA: null, ai: true },
      { key: 'GD2 (máx 4000 mm)', code: 'GD2', value_ai: null, value_human: null, check: null, min: 50, max: 4000, NA: null, ai: true },
    ],
  },
  tercera_luz_freno: {
    dimensiones: [
      { key: '3LF (mín 850 mm)', code: '3LF', value_ai: null, value_human: null, check: null, min: 850, max: 4500, NA: null, ai: true },
    ],
    angulos: [
      { key: 'Ángulo 1 visión horizontal central (10º)', check: true, ai: false },
      { key: 'Ángulo 2 visión horizontal central (10º)', check: true, ai: false },
    ],
    gcs_sketch_images_path: null,
  },
  bandas_refrectantes_laterales_traseras: {
    contraseñas: [
      { key: 'E1 104R 00821 (3M)', code: 'E1 104R 00821 (3M)', check: null, ai: true },
    ],
    color_bandas_laterales: null,
    color_bandas_traseras: null,
    continuidad_descontinuidad: [
      { key: 'El marcado de contorno se considerará continuo si una interrupción no supera el 50% de la longitud del elemento adyacente más corto', check: null, ai: false },
    ],
    dimensiones_laterales: [
      { key: 'RL1 (mín 250 mm)', code: 'RL1', value_ai: null, value_human: null, check: null, min: 250, max: 1500, NA: null, ai: true },
      { key: 'RL2 (mín 250 mm)', code: 'RL2', value_ai: null, value_human: null, check: null, min: 250, max: 1500, NA: null, ai: true },
      { key: 'RL3 (mín 250 mm)', code: 'RL3', value_ai: null, value_human: null, check: null, min: 250, max: 1500, NA: null, ai: true },
      { key: 'RL4 (mín 250 mm)', code: 'RL4', value_ai: null, value_human: null, check: null, min: 250, max: 1500, NA: null, ai: true },
      { key: 'RL5 (máx 600 mm)', code: 'RL5', value_ai: null, value_human: null, check: null, min: null, max: 600, NA: null, ai: true },
      { key: 'RL6 (mín 250 mm)', code: 'RL6', value_ai: null, value_human: null, check: null, min: 250, max: 2500, NA: null, ai: true },
      { key: 'RL7 (máx 2100 mm)', code: 'RL7', value_ai: null, value_human: null, check: null, min: 200, max: 2100, NA: null, ai: true },
    ],
    dimensiones_traseras: [
      { key: 'RT1 (mín 250 mm)', code: 'RT1', value_ai: null, value_human: null, check: null, min: 250, max: 1500, NA: null, ai: true },
      { key: 'RT2 (mín 250 mm)', code: 'RT2', value_ai: null, value_human: null, check: null, min: 250, max: 1500, NA: null, ai: true },
      { key: 'RT3 (mín 250 mm)', code: 'RT3', value_ai: null, value_human: null, check: null, min: 250, max: 1500, NA: null, ai: true },
      { key: 'RT4 (mín 250 mm)', code: 'RT4', value_ai: null, value_human: null, check: null, min: 250, max: 1500, NA: null, ai: true },
      { key: 'RT5 (mín 250 mm)', code: 'RT5', value_ai: null, value_human: null, check: null, min: 250, max: 2500, NA: null, ai: true },
      { key: 'RT6 (máx 2100 mm)', code: 'RT6', value_ai: null, value_human: null, check: null, min: 200, max: 2100, NA: null, ai: true },
    ],
    gcs_sketch_images_path: null,
  },
  bandas_refrectantes_traseras_francia: {
    contraseñas: [
      { key: 'E11 70R 010002', code: 'E11 70R 010002', check: null, ai: true },
    ],
    dimensiones: [
      { key: 'BRT1 (máx 2100 mm)', code: 'BRT1', value_ai: null, value_human: null, check: null, min: 200, max: 2100, NA: null, ai: true },
    ],
    gcs_sketch_images_path: null,
  },
  bandas_refrectantes_delanteras_francia: {
    dimensiones: [
      { key: 'BRD1 (máx 150 mm)', code: 'BRD1', value_ai: null, value_human: null, check: null, min: 50, max: 150, NA: null, ai: true },
      { key: 'BRD2 (mín 1000 mm)', code: 'BRD2', value_ai: null, value_human: null, check: null, min: 50, max: 1000, NA: null, ai: true },
      { key: 'BRD3 (mín 1000 mm)', code: 'BRD3', value_ai: null, value_human: null, check: null, min: 50, max: 1000, NA: null, ai: true },
      { key: 'BRD4 (máx 150 mm)', code: 'BRD4', value_ai: null, value_human: null, check: null, min: 50, max: 150, NA: null, ai: true },
    ],
    gcs_sketch_images_path: null,
  },
  proteccion_lateral_derecho: {
    contraseñas: [
      { key: 'E9 73R 1208 (ADAICO)', code: 'E9 73R 1208--D', check: null, ai: true },
    ],
    dimensiones: [
      { key: 'PLD1 (mín 950 mm)', code: 'PLD1', value_ai: null, value_human: null, check: null, min: 950, max: 1500, NA: null, ai: true },
      { key: 'PLD2 (máx 350 mm)', code: 'PLD2', value_ai: null, value_human: null, check: null, min: null, max: 350, NA: null, ai: true },
      { key: 'PLD3-1 (máx 300 mm)', code: 'PLD3-1', value_ai: null, value_human: null, check: null, min: null, max: 300, NA: null, ai: true },
      { key: 'PLD3-2 (máx 300 mm)', code: 'PLD3-2', value_ai: null, value_human: null, check: null, min: null, max: 300, NA: null, ai: true },
      // { key: 'PLD3-3 (máx 300 mm)', code: 'PLD3-3', value_ai: null, value_human: null, check: null, min: null, max: 300, NA: null, ai: true },
      { key: 'PLD4', code: 'PLD4', value_ai: null, value_human: null, check: null, min: 700, max: 2000, NA: null, ai: true },
      { key: 'PLD5 (máx 300 mm)', code: 'PLD5', value_ai: null, value_human: null, check: null, min: null, max: 300, NA: null, ai: true },
      { key: 'PLD6 (máx 550 mm)', code: 'PLD6', value_ai: null, value_human: null, check: null, min: 50, max: 500, NA: null, ai: true },
      { key: 'PLD7 (mín 100 mm)', code: 'PLD7', value_ai: null, value_human: null, check: null, min: 100, max: 300, NA: null, ai: true },
      { key: 'PLD8 (máx 300 mm)', code: 'PLD8', value_ai: null, value_human: null, check: null, min: 50, max: 300, NA: null, ai: true },
      { key: 'PLD9 (máx 650 mm)', code: 'PLD9', value_ai: null, value_human: null, check: null, min: null, max: 650, NA: null, ai: true },
      { key: 'PLD10-1 (máx 3000 mm)', code: 'PLD10-1', value_ai: null, value_human: null, check: null, min: 100, max: 3000, NA: null, ai: true },
      { key: 'PLD10-2 (máx 3000 mm)', code: 'PLD10-2', value_ai: null, value_human: null, check: null, min: 100, max: 4500, NA: null, ai: true },
      { key: 'PLD10-3 (máx 3000 mm)', code: 'PLD10-3', value_ai: null, value_human: null, check: null, min: 100, max: 4500, NA: null, ai: true },
      { key: 'PLD11 (máx 200 mm)', code: 'PLD11', value_ai: null, value_human: null, check: null, min: null, max: 200, NA: null, ai: true },
      { key: 'PLD12', code: 'PLD12', value_ai: null, value_human: null, check: null, min: 20, max: 500, NA: null, ai: false },
      { key: 'PLD13 (máx 30 mm)', code: 'PLD13', value_ai: null, value_human: null, check: null, min: null, max: 30, NA: null, ai: false },
      { key: 'PLD14 (máx 150 mm)', code: 'PLD14', value_ai: null, value_human: null, check: null, min: null, max: 150, NA: null, ai: false },
    ],
    gcs_sketch_images_path: null,
  },
  proteccion_lateral_izquierdo: {
    contraseñas: [
      { key: 'E9 73R 1208 (ADAICO)', code: 'E9 73R 1208--IZ', check: null, ai: true },
    ],
    dimensiones: [
      { key: 'PLI1 (mín 950 mm)', code: 'PLI1', value_ai: null, value_human: null, check: null, min: 950, max: 1500, NA: null, ai: true },
      { key: 'PLI2 (máx 350 mm)', code: 'PLI2', value_ai: null, value_human: null, check: null, min: null, max: 350, NA: null, ai: true },
      { key: 'PLI3-1 (máx 300 mm)', code: 'PLI3-1', value_ai: null, value_human: null, check: null, min: null, max: 300, NA: null, ai: true },
      { key: 'PLI3-2 (máx 300 mm)', code: 'PLI3-2', value_ai: null, value_human: null, check: null, min: null, max: 300, NA: null, ai: true },
      // { key: 'PLI3-3 (máx 300 mm)', code: 'PLI3-3', value_ai: null, value_human: null, check: null, min: null, max: 300, NA: null, ai: true },
      { key: 'PLI4', code: 'PLI4', value_ai: null, value_human: null, check: null, min: 700, max: 2000, NA: null, ai: true },
      { key: 'PLI5 (máx 300 mm)', code: 'PLI5', value_ai: null, value_human: null, check: null, min: null, max: 300, NA: null, ai: true },
      { key: 'PLI6 (máx 550 mm)', code: 'PLI6', value_ai: null, value_human: null, check: null, min: 50, max: 500, NA: null, ai: true },
      { key: 'PLI7 (mín 100 mm)', code: 'PLI7', value_ai: null, value_human: null, check: null, min: 100, max: 300, NA: null, ai: true },
      { key: 'PLI8 (máx 300 mm)', code: 'PLI8', value_ai: null, value_human: null, check: null, min: 50, max: 300, NA: null, ai: true},
      { key: 'PLI9 (máx 650 mm)', code: 'PLI9', value_ai: null, value_human: null, check: null, min: null, max: 650, NA: null, ai: true },
      { key: 'PLI10-1 (máx 3000 mm)', code: 'PLI10-1', value_ai: null, value_human: null, check: null, min: 100, max: 3000, NA: null, ai: true },
      { key: 'PLI10-2 (máx 3000 mm)', code: 'PLI10-2', value_ai: null, value_human: null, check: null, min: 100, max: 4500, NA: null, ai: true },
      { key: 'PLI10-3 (máx 3000 mm)', code: 'PLI10-3', value_ai: null, value_human: null, check: null, min: 100, max: 4500, NA: null, ai: true },
      { key: 'PLI11 (máx 200 mm)', code: 'PLI11', value_ai: null, value_human: null, check: null, min: null, max: 200, NA: null, ai: true },
      { key: 'PLI12', code: 'PLI12', value_ai: null, value_human: null, check: null, min: 20, max: 500, NA: null, ai: false },
      { key: 'PLI13 (máx 30 mm)', code: 'PLI13', value_ai: null, value_human: null, check: null, min: null, max: 30, NA: null, ai: false },
      { key: 'PLI14 (máx 150 mm)', code: 'PLI14', value_ai: null, value_human: null, check: null, min: null, max: 150, NA: null, ai: false },
    ],
    gcs_sketch_images_path: null,
  },
  sistema_antiproyeccion: {
    contraseñas: [
      { key: 'E9 3000 (KINGOM)', code: null, check: null, ai: false },
    ],
    dimensiones: [
      {
        key: 'Distancia del borde inferior de la faldilla posterior al suelo (máx 200 mm) (*)',
        eje_2: null,
        eje_3: null,
        eje_4: null,
        min: 20,
        max: 200,
        NA: null, ai: false
      },
      {
        key: 'Distancia entre la faldilla posterior y el neumático - Absorbedor de energia (máx 300 mm)',
        eje_2: null,
        eje_3: null,
        eje_4: null,
        min: 20,
        max: 300,
        NA: null, ai: false
      },
      {
        key: 'Anchura de guardabarros (d5) / Anchura de neumático (d5>A)',
        eje_2: null,
        eje_3: null,
        eje_4: null,
        min: null,
        max: null, 
        NA: null, ai: false
      },
      {
        key: 'Anchura de faldilla posterior / Anchura banda rodadura (A)',
        eje_2: null,
        eje_3: null,
        eje_4: null,
        min: null,
        max: null, 
        NA: null, ai: false
      },
      {
        key: 'Angulo de cobertura del dispositivo de antiproyección trasero instalado en el interior del guardabarros (mín 30º)',
        eje_2: null,
        eje_3: null,
        eje_4: null,
        min: 30,
        max: null, 
        NA: null, ai: false
      },
      {
        key: 'Distancia máxima del borde inferior de la faldilla exterior al centro del neumático (Rv)',
        eje_2: null,
        eje_3: null,
        eje_4: null,
        min: 100,
        max: 1500, 
        NA: null, ai: false
      },
      {
        key: 'Altura exterior del guardabarros - d7 (mín 45 mm)',
        eje_2: null,
        eje_3: null,
        eje_4: null,
        min: 45,
        max: 1500, 
        NA: null, ai: false
      },
    ],
    antiproyecciones: [
      {
        key: 'Ausencia de aberturas entre guardabarros y Faldillas',
        check_eje_2: null,
        check_eje_3: null,
        check_eje_4: null,
        ai: false
      },
    ],
    gcs_sketch_images_path: null,
  },
  sistema_antiempotramiento: {
    contraseñas: [
      { key: 'E9 58R032154', code: 'E9 58R032154', check: null, ai: true },
    ],
    dimensiones: [
      { key: 'AT1 (máx 450 mm)', code: 'SAT1', value_ai: null, value_human: null, check: null, min: 20, max: 450, NA: null, ai: false },
      { key: 'AT2 (máx 800 mm)', code: 'SAT2', value_ai: null, value_human: null, check: null, min: null, max: 800, NA: null, ai: false },
      { key: 'AT3', code: 'SAT3', value_ai: null, value_human: null, check: null, min: 200, max: 2500, NA: null, ai: false },
      { key: 'AT4-1 (máx 100 mm)', code: 'SAT4-1', value_ai: null, value_human: null, check: null, min: null, max: 100, NA: null, ai: false },
      { key: 'AT4-2 (máx 100 mm)', code: 'SAT4-2', value_ai: null, value_human: null, check: null, min: null, max: 100, NA: null, ai: false },
      { key: 'AT5', code: 'SAT5', value_ai: null, value_human: null, check: null, min: 200, max: 2750, NA: null, ai: false },
      { key: 'AT6 (mín 120 mm)', code: 'SAT6', value_ai: null, value_human: null, check: null, min: 120, max: 1500, NA: null, ai: false },
    ],
    gcs_sketch_images_path: null,
  },
  luz_matricula: {
    contraseñas: [
      { key: 'E9 1061', code: null, check: null, ai: false },
    ],
    dimensiones: [
      { key: 'ALTURA BORDE SUPERIOR (máx 3900 mm)', code: 'LMABS', value_ai: null, value_human: null, check: null, min: 200, max: 3900, NA: null, ai: true },
      { key: 'ALTURA BORDE INFERIOR (mín 300 mm)', code: 'LMABI', value_ai: null, value_human: null, check: null, min: 300, max: 4500, NA: null, ai: true },
    ],
    posicion: null,
    angulos: [
      { key: 'Ángulos de visión', check: true, ai: false },
    ],
    funcionalidad: true,
    gcs_sketch_images_path: null,
  },
  adhesivo_puntos_ciegos: {
    dimensiones: [
      { key: 'PC1 - Derecha (máx 1500 mm)', code: 'PC1D', value_ai: null, value_human: null, check: null, min: 900, max: 1500, NA: null, ai: true },
      { key: 'PC2 - Derecha (mín 900 mm)', code: 'PC2D', value_ai: null, value_human: null, check: null, min: 900, max: 1500, NA: null, ai: true },
      { key: 'PC3 - Derecha (máx 1000 mm)', code: 'PC3D', value_ai: null, value_human: null, check: null, min: 100, max: 1000, NA: null, ai: true },
      { key: 'PC1 - Izquierda (máx 1500 mm)', code: 'PC1I', value_ai: null, value_human: null, check: null, min: 900, max: 1500, NA: null, ai: true },
      { key: 'PC2 - Izquierda (mín 900 mm)', code: 'PC2I', value_ai: null, value_human: null, check: null, min: 900, max: 1500, NA: null, ai: true },
      { key: 'PC3 - Izquierda (máx 1000 mm)', code: 'PC3I', value_ai: null, value_human: null, check: null, min: 100, max: 1000, NA: null, ai: true },
      { key: 'PC4  (máx 1500 mm)', code: 'PC4', value_ai: null, value_human: null, check: null, min: 100, max: 1500, NA: null, ai: true },
    ],
    adhesivo_puntos_ciegos: [
      { key: 'Derecha', check: null, ai: true },
      { key: 'Izquierda', check: null, ai: true },
      { key: 'Trasera', check: null, ai: true },
    ],
    gcs_sketch_images_path: null,
  },
  proteccion_delantera: {
    dimensiones: [
      { key: 'INSTALACIÓN DE TOMA DE FUERZA FRONTAL INCREMENTANDO VOLADIZO DELANTERO EN (máx 400 mm)', code: 'PRD1', value_ai: null, value_human: null, check: null, min: null, max: 400, NA: null, ai: false },
      { key: 'INSTALACIÓN DE SISTEMA DE RIEGO FRONTAL INCREMENTANDO VOLADIZO DELANTERO EN (máx 400 mm)', code: 'PRD2', value_ai: null, value_human: null, check: null, min: null, max: 400, NA: null, ai: false },
    ],
    angulos: [
      { key: 'El paragolpes original del vehículo no se modifica en cuanto a instalación, resistencia, ubicación, dimensiones, etc.', check: null, ai: false },
      { key: 'La instalación del equipo se realiza siempre en un plano horizontal superior al del paragolpes de origen y a una altura no superior a 2 metros.', check: null, ai: false },
      { key: 'Su instalación no disminuye la resistencia mecánica del paragolpes original', check: null, ai: false },
      { key: 'El equipo está provisto de una carcasa exterior metálica o de plástico', check: null, ai: false },
      { key: 'El incremento de la longitud del voladizo delantero respecto al vehículo de origen homologado no es superior a 400 mm (d1) (mm.)', check: null, ai: false },
      { key: 'Todos los elementos instalados están protegidos con carcasa, la cual tiene unos radios de curvatura superiores a 5 mm (d2) (mm.)', check: null, ai: false },
      { key: 'Batalla igual o inferior a 7.800 mm y Voladizo delantero de la cabina (origen) no superior a 1.500 mm', check: null, ai: false },
      { key: 'El sistema no interfiere con el dispositivo de remolcado del vehículo', check: null, ai: false },
      { key: 'Ángulos de visibilidad hacia el interior de los dispositivos de luz de carretera(*)', check: null, ai: false },
      { key: 'Ángulos de visibilidad hacia el interior de los dispositivos de luz de cruce(**)', check: null, ai: false },
    ],
    gcs_sketch_images_path: null,
  },
  deposito_combustible_addblue: {
    dimensiones: [
      { key: 'DC1', code: 'DC1', value_ai: null, value_human: null, check: null, min: 200, max: 1500, NA: null, ai: true },
      { key: 'DC2', code: 'DC2', value_ai: null, value_human: null, check: null, min: 200, max: 4000, NA: null, ai: true },
      { key: 'DC3', code: 'DC3', value_ai: null, value_human: null, check: null, min: null, max: null, NA: null, ai: false },
      { key: 'DA1', code: 'DA1', value_ai: null, value_human: null, check: null, min: 200, max: 1500, NA: null, ai: true },
      { key: 'DA2', code: 'DA2', value_ai: null, value_human: null, check: null, min: 200, max: 4000, NA: null, ai: true },
      { key: 'DA3', code: 'DA3', value_ai: null, value_human: null, check: null, min: null, max: null, NA: null, ai: false },
    ],
    litros: [
      { key: 'Litros gasóleo', value_ai: null, value_human: null, NA: null, ai: false },
      { key: 'Litros adblue', value_ai: null, value_human: null, NA: null, ai: false },
    ],
    gcs_sketch_images_path: null,
  },
  neumaticos: [
    { key: 'Neumático 1er eje', descripcion: '', indice: '', tipo: null, ai: false },
    { key: 'Neumático 2º eje', descripcion: '', indice: '', tipo: null, ai: false },
    { key: 'Neumático 3er eje', descripcion: '', indice: '', tipo: null, ai: false },
    { key: 'Rueda repuesto', descripcion: '', indice: '', present: null, ai: false },
  ],
  etiquetas_limite_velocidad_francia: {
    posicion: [
      { key: 'Los discos están dispuestos en orden ascendente de arriba a bajo o de izquierda a derecha.', check: null, ai: true },
    ],
    etiquetas: [
      { key: '80', code:'80', check: null, ai: true },
      { key: '90', code:'90', check: null, ai: true },
    ],
    gcs_sketch_images_path: null,
  },
  extintores_francia: {
    posicion: [
      { key: 'Extintor en cabina', check: null, posicion: null, ai: false },
      { key: 'Extintor en caja 1 (camiones >7.5tn)', check: null, posicion: null, ai: false },
      { key: 'Extintor en caja 2 (opcional)', check: null, posicion: null, ai: false },
    ],
    descripcion: [
      { key: 'Extintor en cabina', n_serie: null, fecha: null, ai: false },
      { key: 'Extintor en caja 1', n_serie: null, fecha: null, ai: false },
      { key: 'Extintor en caja 2', n_serie: null, fecha: null, ai: false },
    ],
  },
  depositos_combustible: {
    dimensiones: [
      { key: 'OD1', code: 'OD1', value_ai: null, value_human: null, check: null, min: 150, max: 3000, NA: null, ai: true },
      { key: 'OD2', code: 'OD2', value_ai: null, value_human: null, check: null, min: 150, max: 4000, NA: null, ai: true },
      { key: 'OD3', code: 'OD3', value_ai: null, value_human: null, check: null, min: 100, max: 600, NA: null, ai: true },
      { key: 'OD4', code: 'OD4', value_ai: null, value_human: null, check: null, min: 100, max: 3000, NA: null, ai: true },
      { key: 'OD5', code: 'OD5', value_ai: null, value_human: null, check: null, min: null, max: 500, NA: null, ai: true},
    ],
    gcs_sketch_images_path: null,
  },
  cem_francia: {
    contraseñas: [
      { key: 'Faro de trabajo E9 10R-04.6881', code: 'E9 10R-04.6881',  value_ai: null, value_human: null, NA: null, ai: true },
      { key: 'Triangulo 10R E2 04 03069 - SESALY', code: null, value_ai: null, value_human: null, NA: null, ai: false },
      { key: 'Camara trasera E11 10R 05 9700', code: null, value_ai: null, value_human: null, NA: null, ai: false },
      { key: 'Pantalla E11 10R - 05 9060', code: null, value_ai: null, value_human: null, NA: null, ai: false },
    ],
    funcionalidad: true,
  },
  checks: [
    { key: 'Chaleco reflectante', check: null, ai: false },
    { key: 'Placa fabricante (ROSROCA)', check: null, ai: false },
    { key: 'Placa de TARA (FRANCIA)', check: null, ai: false },
  ],
  resultado: {
    resultado: null,
    notas: null,
  },
} as any; // Type assertion needed due to complex nested types
